module.exports = __webpack_public_path__ + "8943e6b019d5b622fddc504690bb7f3a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/long-s.png
// module id = 1895
// module chunks = 0